import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import Map from 'components/Map';
import ProjectMarkers from 'components/ProjectMarkers';

import css from './ActiveProjectsMapBlock.module.scss';

class ActiveProjectsMapBlock extends React.PureComponent {
    static propTypes = {
        header: PropTypes.string,
        maxClusterRadius: PropTypes.number.isRequired,
        projects: PropTypes.arrayOf(PropTypes.shape({
            location: PropTypes.string.isRequired,
        })),
        projectStatusLabel: PropTypes.string.isRequired,
        projectsLink: PropTypes.string,
        projectsLinkHeading: PropTypes.string,
        tileLayer: PropTypes.string
    }

    static defaultProps = {
        maxClusterRadius: 40,
    }

    render() {
        const {
            header,
            maxClusterRadius,
            projects,
            projectStatusLabel,
            projectsLink,
            projectsLinkHeading,
            tileLayer
        } = this.props;

        return (
            <div className={css.block}>
                {header && (
                    <header className={css.header}>
                        <h2 className="block-title-large">{header}</h2>
                    </header>
                )}
                <div className={css.map}>
                    <Map
                        center={[61.606396, 21.225586]}
                        fitMarkers={true}
                        zoomLevel={1}
                        tileLayer={tileLayer}
                    >
                        <ProjectMarkers
                            filterSearch={() => true}
                            maxClusterRadius={maxClusterRadius}
                            projects={projects || []}
                            projectStatusLabel={projectStatusLabel}
                        />
                    </Map>
                </div>
                {projectsLinkHeading && projectsLink && (
                    <div className={css.seeAll}>
                        <Button href={projectsLink} light secondary>
                            {projectsLinkHeading}
                        </Button>
                    </div>
                )}
            </div>
        );
    }
}

export default ActiveProjectsMapBlock;



// WEBPACK FOOTER //
// ./src/components/ActiveProjectsMapBlock/ActiveProjectsMapBlock.jsx